<template>
  <div class="poster">
    <div class="box">
      <img src="@/assets/imgs/poster/bgc.png" alt="">
    </div>
    <img
      @click="showApp"
      class="btn"
      src="@/assets/imgs/poster/btn.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  data(){
    return {
    }
  },
  mounted() {
  },
  methods: {
    showApp() {
      window.location.href = 'yoclawyer://yoclawyer/open?path=SET_HUOKE_PAGE'
      setTimeout(()=>{
        window.location.href = 'https://cldownload.imlaw.cn/'
      },3000)
    },
  },
};
</script>

<style lang="scss" scoped>
.poster {
  background-image: linear-gradient(to right,#7a0505,#b92405);
  .box{
    min-height: 100vh;
    img{
      width: 100%;
      height: 780px;
    }
  }
  .btn {
    width: 330px;
    height: 44px;
    position: fixed;
    bottom: 53px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>